<div class="m-3">
  <div class="row">
    <div class="col-lg-4 col-md-12">
      <div class="card">
        <div class="card-header">Tổng quan</div>
        <div class="card-body">
          <ul class="list-group list-group-flush">
            <li class="list-group-item font-weight-bold" *ngIf="numberOfCooperative">Tổng số HTX: <a routerLink="/meter-cooperative/cooperative">{{numberOfCooperative || ''}}</a></li>
            <li class="list-group-item font-weight-bold">Tổng số Trạm: <a routerLink="/meter-cooperative/cooperative/{{cooperativeNo}}">{{numberOfStation || ''}}</a></li>
            <li class="list-group-item font-weight-bold">Tổng số KH: <a routerLink="/meter-cooperative/cooperative/{{cooperativeNo}}">{{numberOfCustomer || ''}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
